export default "__VITE_ASSET__9D$ztyl6__"